import React from 'react';
import LoadingSpinner from './Generic/LoadingSpinner';
import Card from './Generic/Card';
import RichTextDisplay from './Generic/RichTextDisplay';
import HTMLDocxLink from './Generic/HTMLDocxLink';
import useProfile from '../Provider/TableContext/ProfileContext';

const Description = (HTML) => () => <HTMLDocxLink HTML={HTML} rotate pageType='A3' name="MyABCs"> Download MyABCs</HTMLDocxLink>;

export default function MyABCs() {
    const { profileData, loading } = useProfile();

    const children = loading || !profileData?.mcb_myabcs? <LoadingSpinner/> : <RichTextDisplay value={profileData.mcb_myabcs}/>;
    
    return (
        <Card
            title="MyABCs"
            className="w-100"
            description="Downloads this ABC as MS Word Document"
            DescriptionControl={profileData?.mcb_myabcs && Description(profileData.mcb_myabcs)}
        >
            {children}
        </Card>
    );
}